/**
 * TimeInput element is a logic for a special time handling input field.
 * Input field has no date information, only time of day is handled here.
 * Input is given as a "hh:mm" format where hh stand for hours and mm minutes.
 */
class TimeInputNative {

  /**
   * @constructor
   * @param {HTMLInputElement} element an element to bind time input logic. This field is going to be hidden and replaced with two input fields that are shown in UI
   * @throws {TypeError} when given element is not an instance of HTMLInputElement
   */
  constructor(element) {

    if( !(element instanceof HTMLInputElement) ) {
      throw TypeError('Given element is not an HTMLInputElement');
    }

    this._element = element;

    this._bind();
  }

  /**
   * Bind event listeners to pseudo element
   */
  _bind() {
    this._element.addEventListener('blur', this._onBlur.bind(this));
  }

  /**
   * Called when a input element has lost focus
   * @param {Event} event event object
   */
  _onBlur(event) {
    const time = event.target.value;
    const step = parseInt(event.target.step) ? parseInt(event.target.step / 60) : false; // Convert milliseconds to seconds

    if (time && step > 0) {
      let [hours, minutes] = time.split(':').map(Number);
      const roundedMinutes = (Math.round(minutes / step) * step) % 60;
      const roundedHours = minutes > (60 - (step / 2)) ? (hours === 23 ? 0 : ++hours) : hours;
      const roundedTime = `${roundedHours.toString().padStart(2, '0')}:${roundedMinutes.toString().padStart(2, '0')}`;

      event.target.value = roundedTime;
    }
  }

}

export default TimeInputNative;
